export const convertNumber = (number) => {
  // Add commas to the number
  const numberWithCommas = number.toLocaleString();
  
  // Split the formatted number by commas
  var arr = numberWithCommas.split(",");
  
  // Check the length of the array to determine the abbreviation
  if (arr.length == 5) {
      // Trillions
      return arr[0] + "." + arr[1].slice(0, 2) + "T";
  } else if (arr.length == 4) {
      // Billions
      return arr[0] + "." + arr[1].slice(0, 2) + "B";
  } else if (arr.length == 3) {
      // Millions
      return arr[0] + "." + arr[1].slice(0, 2) + "M";
  } else if (arr.length == 2) {
      // Thousands
      return arr[0] + "." + arr[1].slice(0, 2) + "K";
  } else {
      // Hundreds
      return numberWithCommas;
  }
};
